module.exports = __webpack_public_path__ + "static/media/davidconde.7fd1d937.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/davidconde.webp
// module id = 784
// module chunks = 0